"use client"
import { Component } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { URL_PATH } from "../../services/API"
import API from "../../services/API"
import redux from "../../common/Redux"
import Modal from "../../components/Modal"
import Toast from "../../components/Toast"
import Button from "@mui/material/Button"
import ReportTable from "../../components/ReportTable"

const theme = {
  background: "#02111B",
  btnColor: "#FFC857",
    blackColor: "#041A29",

  dropdownColor: "#041A29",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  primary: "#ffc857",
  secondary: "#bb0a21",
  white: "#ffffff",
  drawerBgColor: "#16232c",
  pageBgColor: "#041A29",
  redColor: "#ed1c24",
  greenColor: "#00a651",
  blueColor: "#00a8ff",
  mutedWhite: "#9CA3AF",
  rootBgColor: "#02111b",
}

class CategorySalesReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      version: 1,
      loading: false,
      modalVisible: false,
      modalData: null,
      startDate: null,
      endDate: null,
      selectedSearchFilter: "",
      searchContent: "",
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
    }
  }

  handleToastClose = () => {
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  onView = (item) => {
    this.setState({
      modalVisible: true,
      modalData: item,
    })
  }

  formatDateForAPI = (date) => {
    if (!date) return ""
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, "0")
    const day = String(date.getDate()).padStart(2, "0")
    return `${year}-${month}-${day}`
  }

  getSearchOptions = () => [
    { value: "", label: "Select Search Filter" },
    { value: "channel", label: "Channel (e.g., dinein, takeaway)" },
    { value: "item_name", label: "Item Name" },
    { value: "min_orders", label: "Minimum Orders" },
    { value: "max_orders", label: "Maximum Orders" },
    { value: "min_qty_sold", label: "Minimum Quantity Sold" },
    { value: "max_qty_sold", label: "Maximum Quantity Sold" },
    { value: "min_total_sales", label: "Minimum Total Sales" },
    { value: "max_total_sales", label: "Maximum Total Sales" },
    { value: "min_profit_margin", label: "Minimum Profit Margin %" },
    { value: "max_profit_margin", label: "Maximum Profit Margin %" },
  ]

  getApiUrl = (exportType = "") => {
    const { selectedHotelId } = this.props
    const { startDate, endDate, selectedSearchFilter, searchContent } = this.state

    const fromDate = this.formatDateForAPI(startDate)
    const toDate = this.formatDateForAPI(endDate)

    let url = URL_PATH.report(selectedHotelId.id, "category_sales", fromDate, toDate, exportType, selectedSearchFilter, searchContent)

    return url
  }

  exportReport = async (type) => {
    const { status, message } = await API(this, "get", this.getApiUrl(type))
    if (status === "success") {
      this.showToast(message, "success")
      this.setState({
        version: this.state.version + Math.random(),
      })
    } else {
      this.showToast(message, "error")
    }
  }

  applyDateFilter = () => {
    this.setState({
      version: this.state.version + Math.random(),
    })
  }

  handleSearchChange = (searchContent) => {
    this.setState({ searchContent }, () => {
      // Auto-search on change with debounce
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.setState({
          version: this.state.version + Math.random(),
        })
      }, 500)
    })
  }

  handleSearchFilterChange = (selectedSearchFilter) => {
    this.setState({ selectedSearchFilter, searchContent: "" }, () => {
      if (!selectedSearchFilter) {
        this.setState({
          version: this.state.version + Math.random(),
        })
      }
    })
  }

  ExampleCustomInput = ({ value, onClick, placeholder }) => (
    <button
      onClick={onClick}
      style={{
        backgroundColor: theme.dropdownColor,
        color: theme.white,
        border: `1px solid ${theme.greybordercolor}`,
        borderRadius: "4px",
        padding: "10px 16px",
        cursor: "pointer",
        fontSize: "14px",
        minWidth: "140px",
        textAlign: "left",
      }}
    >
      {value || placeholder}
    </button>
  )

  render() {
    const { modalData, modalVisible, toast, startDate, endDate } = this.state

    return (
      <div
        style={{
          backgroundColor: theme.rootBgColor,
          minHeight: "100vh",
          padding: "20px",
        }}
      >
        <ReportTable
          key={this.state.version}
          export={true}
          api={this.getApiUrl()}
          title="Category Sales Analysis"
          // searchPlaceholder="Search by category name"
          onView={this.onView}
          exportFileName="CategorySales"
          nestedKey="top_items"
          dateFilter={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <DatePicker
                selected={startDate}
                onChange={(date) => this.setState({ startDate: date })}
                isClearable={false}
                closeOnScroll={true}
                placeholderText="Start Date"
                customInput={<this.ExampleCustomInput />}
                dateFormat="yyyy-MM-dd"
              />
              <DatePicker
                selected={endDate}
                onChange={(date) => this.setState({ endDate: date })}
                isClearable={false}
                closeOnScroll={true}
                placeholderText="End Date"
                customInput={<this.ExampleCustomInput />}
                dateFormat="yyyy-MM-dd"
              />
              <Button
                variant="contained"
                onClick={this.applyDateFilter}
                sx={{
                  textTransform: "none",
                  backgroundColor: theme.btnColor,
                  color: "black",
                  "&:hover": { backgroundColor: theme.btnColor },
                  fontWeight: "700",
                  padding: "8px 20px",
                }}
              >
                Apply
              </Button>
              {(this.state.startDate || this.state.endDate) && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    this.setState({
                      startDate: null,
                      endDate: null,
                      version: this.state.version + Math.random(),
                    })
                  }
                sx={{
                    textTransform: "none",
                    backgroundColor: "#BB0A21",
                    borderColor:"#BB0A21",
                    color: theme.white,
                    "&:hover": {borderColor:"#BB0A21",  backgroundColor: "#BB0A21" },
                    fontWeight: "700",
                    padding: "8px 20px",
                  }}
                >
                  Clear 
                </Button>
              )}
            </div>
          }
          advancedSearch={
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <select
                value={this.state.selectedSearchFilter}
                onChange={(e) => this.handleSearchFilterChange(e.target.value)}
                style={{
                  backgroundColor: theme.dropdownColor,
                  color: theme.white,
                  border: `1px solid ${theme.greybordercolor}`,
                  borderRadius: "4px",
                  padding: "12px 16px",
                  fontSize: "14px",
                  minWidth: "200px",
                }}
              >
                {this.getSearchOptions().map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {this.state.selectedSearchFilter && (
                <input
                  type="text"
                  placeholder="Enter search value"
                  value={this.state.searchContent}
                  onChange={(e) => this.handleSearchChange(e.target.value)}
                  style={{
                    backgroundColor: theme.dropdownColor,
                    color: theme.white,
                    border: `1px solid ${theme.greybordercolor}`,
                    borderRadius: "4px",
                    padding: "10px 16px",
                    fontSize: "14px",
                    minWidth: "150px",
                  }}
                />
              )}
              {/* {this.state.selectedSearchFilter && (
                <Button
                  variant="outlined"
                  onClick={() =>
                    this.setState({
                      selectedSearchFilter: "",
                      searchContent: "",
                      version: this.state.version + Math.random(),
                    })
                  }
                  sx={{
                    textTransform: "none",
                    backgroundColor: "#BB0A21",
                    borderColor:"#BB0A21",
                    color: theme.white,
                    "&:hover": {borderColor:"#BB0A21",  backgroundColor: "#BB0A21" },
                    fontWeight: "700",
                    padding: "8px 20px",
                  }}
                >
                  CLEAR SEARCH
                </Button>
              )} */}
            </div>
          }
          columns={[
            {
              title: "Category",
              key: "category_name",
              nestedKey: "item_name",
            },
            {
              title: "Orders",
              key: "total_orders",
              nestedKey: "number_of_orders",
              format: (val) => val?.toLocaleString() || "0",
              nestedFormat: (val) => val?.toLocaleString() || "0",
            },
            {
              title: "Quantity Sold",
              key: "total_qty_sold",
              nestedKey: "total_qty_sold",
              format: (val) => val?.toLocaleString() || "0",
              nestedFormat: (val) => val?.toLocaleString() || "0",
            },
            {
              title: "Total Sales",
              key: "total_sales",
              nestedKey: "total_sales",
              format: (val) => `₹${val?.toFixed(2) || "0.00"}`,
              nestedFormat: (val) => `₹${val?.toFixed(2) || "0.00"}`,
            },
            {
              title: "Net Sales",
              key: "net_sales",
              nestedKey: "net_sales",
              format: (val) => `₹${val?.toFixed(2) || "0.00"}`,
              nestedFormat: (val) => `₹${val?.toFixed(2) || "0.00"}`,
            },
            {
              title: "Gross Profit",
              key: "gross_profit",
              nestedKey: "gross_profit",
              format: (val) => `₹${val?.toFixed(2) || "0.00"}`,
              nestedFormat: (val) => `₹${val?.toFixed(2) || "0.00"}`,
            },
            {
              title: "Profit Margin",
              key: "profit_margin",
              nestedKey: "profit_margin",
              format: (val) => `${val?.toFixed(2) || "0.00"}%`,
              nestedFormat: (val) => `${val?.toFixed(2) || "0.00"}%`,
            },
            {
              title: "Avg Order Value",
              key: "average_order_value",
              nestedKey: "average_price",
              format: (val) => `₹${val?.toFixed(2) || "0.00"}`,
              nestedFormat: (val) => `₹${val?.toFixed(2) || "0.00"}`,
            },
            {
              title: "Contribution %",
              key: "percentage_contribution",
              nestedKey: "percentage_contribution",
              format: (val) => `${val?.toFixed(2) || "0.00"}%`,
              nestedFormat: (val) => `${val?.toFixed(2) || "0.00"}%`,
            },
          ]}
        />

        {/* Category Details Modal */}
        {modalVisible && modalData && (
          <Modal
            visible={modalVisible}
            onClose={() => {
              this.setState({
                modalVisible: false,
                modalData: null,
              })
            }}
            title={`Category Details: ${modalData.category_name}`}
            width="90%"
          >
            <div
              style={{
                padding: "20px",
                backgroundColor: theme.background,
                color: theme.white,
                maxHeight: "70vh",
                overflowY: "auto",
              }}
            >
              {/* Category Summary */}
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  gap: "16px",
                  marginBottom: "24px",
                }}
              >
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Total Orders</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.total_orders?.toLocaleString() || "0"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Total Sales</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    ₹{modalData.total_sales?.toFixed(2) || "0.00"}
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Profit Margin</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.profit_margin?.toFixed(2) || "0.00"}%
                  </p>
                </div>
                <div
                  style={{
                    backgroundColor: theme.pageBgColor,
                    padding: "16px",
                    borderRadius: "8px",
                    border: `1px solid ${theme.greybordercolor}`,
                  }}
                >
                  <h4 style={{ color: theme.btnColor, margin: "0 0 8px 0" }}>Contribution</h4>
                  <p style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
                    {modalData.percentage_contribution?.toFixed(2) || "0.00"}%
                  </p>
                </div>
              </div>

              {/* Top Items Table */}
              {modalData.top_items && modalData.top_items.length > 0 && (
                <div>
                  <h3 style={{ color: theme.btnColor, marginBottom: "16px" }}>Top Items</h3>
                  <div style={{ overflowX: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        backgroundColor: theme.pageBgColor,
                        borderRadius: "8px",
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: theme.drawerBgColor }}>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Item Name
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Orders
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Qty Sold
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Sales
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Profit
                          </th>
                          <th
                            style={{
                              padding: "12px",
                              textAlign: "left",
                              borderBottom: `2px solid ${theme.btnColor}`,
                              color: theme.btnColor,
                              fontWeight: "600",
                            }}
                          >
                            Channels
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {modalData.top_items.map((item, index) => (
                          <tr
                            key={item.item_id}
                            style={{
                              backgroundColor: index % 2 === 0 ? theme.background : theme.pageBgColor,
                            }}
                          >
                            <td
                              style={{
                                padding: "12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.white,
                                fontWeight: "500",
                              }}
                            >
                              {item.item_name}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.white,
                              }}
                            >
                              {item.number_of_orders?.toLocaleString() || "0"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.white,
                              }}
                            >
                              {item.total_qty_sold?.toLocaleString() || "0"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.white,
                              }}
                            >
                              ₹{item.total_sales?.toFixed(2) || "0.00"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.white,
                              }}
                            >
                              ₹{item.gross_profit?.toFixed(2) || "0.00"}
                            </td>
                            <td
                              style={{
                                padding: "12px",
                                borderBottom: `1px solid ${theme.greybordercolor}`,
                                color: theme.mutedWhite,
                                fontSize: "12px",
                              }}
                            >
                              {item.channels || "N/A"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          </Modal>
        )}

        <Toast
          open={toast.open}
          message={toast.message}
          severity={toast.severity}
          handleClose={this.handleToastClose}
        />
      </div>
    )
  }
}

export default redux(CategorySalesReport)
